import React from 'react'
import {
	useDispatch,
	useSelector
} from 'react-redux'
import { Link } from 'react-router-dom'
import { selectClientsById, selectTrainerParam } from '../users/usersSlice'
import { fullBasePath } from '../../util/util'
import ProgressBar from 'react-bootstrap/ProgressBar'
import RowOptions from './RowOptions/RowOptions'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import styles from './ClientRow.module.css'
import {
	updateExpandedData,
	toggleExpandedData,
	updateCalendarClientSelected
} from '../../state/events'
import {
	deleteClient,
	clearTrainerNewMessageFlag
} from '../users/usersSlice'
import {
	updateShow as updateShowChat,
	updateRecipient as updateChatRecipient
} from '../chat/chatSlice'
import {
	getChatRooms,
	getChatRoom,
	selectMemberPrivateRoomId,
	selectMemberRoomNewMessageCount,
	setShow as setShowMessageCenter
} from '../MessageCenter/messageCenterSlice'
import Button from 'react-bootstrap/Button'
import AlertBubble from '../AlertBubble/AlertBubble'

//helper functions
const capitalize = (s) => {
	if (typeof s !== 'string') return ''
	return s.charAt(0).toUpperCase() + s.slice(1)
}

/*
*	Capitalizes and pluralizes (if needed)
*/
const formatDataNames = name => {
	if (['workout', 'task'].includes(name)) name = name + 's'
	name = capitalize(name)
	return name
}

const ProfileImage = ({ src, alt }) => (
	src !== '' ?
		<img
			alt={alt}
			className="m-1"
			style={{
				width: '40px',
				height: '40px',
				objectFit: 'cover',
				borderRadius: '20px',
				backgroundColor: '#1171ef'
			}}
			src={src} />
		:
		<span
			className="m-1"
			style={{
				width: '40px',
				height: '40px',
				borderRadius: '20px',
				backgroundColor: '#1171ef',
				color: '#eee',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			}}>
			<i className="fas fa-user" />
		</span>
)

const Tags = ({ tags }) => (
	tags.length > 0 ?
		<div className="d-flex align-items-center" style={{flex:'0 0 auto',height:'10px'}}>
			{tags.map(tag => (
				<span style={{
					border: '0.5px solid #888',
					display: 'inline-block',
					background: tag.color,
					width: '10px',
					height: '10px',
					borderRadius: '100%',
					marginRight: '1px'
				}} />
			))}
		</div> :
		null
)

const ClientInfo = ({ user_id_number, shared, user_name, inactivate_account,tags}) => {
	const trainerParam = useSelector(selectTrainerParam)
	const dispatch = useDispatch()

	const openChatHandler = () => {
		dispatch(getChatRoom({
			room_id:privateChatRoomId
		}))
		dispatch(setShowMessageCenter(true))
	} 
	const privateChatRoomId = useSelector(
		state => selectMemberPrivateRoomId(state,user_id_number)
	)
	const client = useSelector(state => selectClientsById(state, user_id_number))
	const newMessageCount = useSelector(
		state=>selectMemberRoomNewMessageCount(state,privateChatRoomId)
	)

	return (
		<div className={styles.ClientInfo}>
			<div className="d-flex flex-wrap align-items-center">
				<Link
					className="mr-2"
					style={{ 
						fontWeight: 500, 
						maxWidth:'260px', 
						textOverflow:'ellipsis',
						overflow:'hidden', 
						whiteSpace:'nowrap'
					}}
					to={`/clientEditor?clientId=${user_id_number}&${trainerParam}`}
				>
					{user_name}
				</Link>
				{
					shared ?
						<small className="d-block text-danger">(shared)</small> :
						null
				}
			</div>
			<Tags tags={tags} />
			<div className={styles.rowOptions}>
			
				<OverlayTrigger overlay={
					<Tooltip>
						Metric Progress Graphs
					</Tooltip>
				}>

					<Button
						className={`m-1 ${styles.metricBTN}`}
						size="sm"
						variant="outline-info"
						style={{
							color:"#9400d3",
							borderColor:"#9400d3",
						}}
						as={Link}
						to={`/metric-graphs?clientId=${user_id_number}&${trainerParam}`}
					>
						<i className="fas fa-chart-line"></i>
					</Button>
				</OverlayTrigger>

				<OverlayTrigger overlay={
					<Tooltip>
						Exercise Progress Graphs
					</Tooltip>
				}>


					<Button
						className={`m-1 ${styles.progressBTN}`}
						size="sm"
						variant="outline-info"
						style={{
							color:"#d39400",
							borderColor:"#d39400",
						}}
						as={Link}
						to={`/exercise_progress/?client=${user_id_number}&${trainerParam}`}
					>
						<i className="fas fa-dumbbell"></i>
					</Button>
				</OverlayTrigger>	
				<OverlayTrigger overlay={
					<Tooltip>
						Wearable Data Graphs
					</Tooltip>
				}>

					<Button
						className={`m-1 ${styles.healthBTN}`}
						size="sm"
						variant="outline-primary"
						style={{
							color:"rgb(255 0 24)",
							borderColor:"#838181",
						}}
						as={Link}
						to={`/wearables?clientId=${user_id_number}&${trainerParam}`}
					>
						<i className="fas fa-heart"></i>
					</Button>
				</OverlayTrigger>

				<OverlayTrigger overlay={
					<Tooltip>
						Achievements
					</Tooltip>
				}>
					<Button
						className="m-1"
						size="sm"
						variant="outline-info"
						as={Link}
						to={`/achievements?client=${user_id_number}&${trainerParam}`}
					>
						<i className="fa fa-trophy"></i>
					</Button>
				</OverlayTrigger>
				
				<OverlayTrigger overlay={
					<Tooltip>
						Progress Pictures
					</Tooltip>
				}>
					<Button
						variant='outline-primary'
						className='m-1'
						size='sm'
						as={Link}
						to={`/photo_reel?client=${user_id_number}&${trainerParam}`}
					>
						<i className="far fa-images"></i>
					</Button>
				</OverlayTrigger>

				
				<OverlayTrigger overlay={
					<Tooltip>
						Open Chat
					</Tooltip>
				}>
					<Button
						className="m-1 position-relative"
						size="sm"
						variant="outline-success"
						onClick={openChatHandler}
					>
						<i className="fas fa-comment"></i>
						{newMessageCount?(<AlertBubble />):null}
					</Button>
				</OverlayTrigger>

				<OverlayTrigger overlay={
					<Tooltip>
						Delete this client
					</Tooltip>
				}>
					<Button
						className="m-1"
						size="sm"
						variant="outline-danger"
						onClick={()=>{
							if(window.confirm('Are you sure?')){
								dispatch(deleteClient(client.user_id_number)).then(()=>{
									dispatch(getChatRooms())
								})
							} 
						}}
					>
						<i className="fas fa-trash"></i>
					</Button>

					</OverlayTrigger>
			</div>
		</div>
	)
}

const ComplianceInfo = ({ dataToDisplay, compliance, clientId, user_name }) => {
	let dispatch = useDispatch();
	const trainerParam = useSelector(selectTrainerParam)
	const isMAXUser = useSelector(state => Boolean(state.users?.current_user?.isMAXUser))
	
	const openExpandedDataHandler = (expandData)=>{
		dispatch(updateExpandedData(expandData));
		dispatch(toggleExpandedData());
	}
	
	
	return (
		<div className={styles.Bars}>
			{['workout', 'task', 'nutrition'].map(key => {
				if (dataToDisplay !== 'all' && key !== dataToDisplay) return null
				//grab data object from client props object

				const data = compliance[key]

				//get data and make sure it is valid
				let complete = parseInt(data.complete)
				if (isNaN(complete)) complete = 0

				let open = parseInt(data.open)
				if (isNaN(open)) open = 0

				let notMet = parseInt(data.notMet)
				if (isNaN(notMet)) notMet = 0


				const total = complete + open + notMet
				//to avoid division by zero ensure that (total >= 1)
				const safeTotal = total || 1
				//calculate the percentages
				const completePercent = (complete / safeTotal * 100)
				const openPercent = (open / safeTotal * 100)
				const notMetPercent = (notMet / safeTotal * 100)


				const generateLabel =(percent, count) => {
					return (
						<div className={styles.ComplianceContainer}>
							<div className="mx-1">{percent}% </div>
							<div className={styles.ComplianceCountLarge}>{count}</div>
							<div className={styles.ComplianceCountMed}>({count})</div>
						</div>
					)
				}
				//location to send user to
				const location =
					`/eventsView?display=all&selector=all&filter=client&client=${clientId}&${trainerParam}`

				//form object to map to JSX
				const barData = [
					{
						percent: completePercent,
						count: complete,
						variant: 'success',
					}, {
						percent: notMetPercent,
						count: notMet,
						variant: 'danger',
					}, {
						percent: openPercent,
						count: open,
						variant: 'secondary',
					},
				]
				if (
					key === 'nutrition' &&
					compliance.simplified_nutrition.assigned &&
					total === 0
				) return null
				return (
					<div key={key} className={styles.EventData}>
						<small className={styles.EventName}>
							<Link to={location} className="d-block">
									{formatDataNames(key)}
							</Link>
						</small>
						<ProgressBar
							onClick={() => {
								const expandData = {
									clientName: user_name,
									title: capitalize(key),
									linkText: formatDataNames(key),
									complete,
									notMet,
									open,
									location
								}
								openExpandedDataHandler(expandData)
							}}
							className={styles.ProgressBar}
							key={key}>
							{barData.map((data, i) => (
								<ProgressBar
									variant={data.variant}
									now={data.percent}
									label={ generateLabel(
										(Math.round(data.percent) !== data.percent ?
											data.percent.toFixed(0) :
											data.percent),
											data.count

									)
										// `${
										// //only truncate to two decimals if
										// //the percentage is a non-int
										// Math.round(data.percent) !== data.percent ?
										// 	data.percent.toFixed(0) :
										// 	data.percent
										// }%
										
										// (${data.count})`
									}
									key={i} />
							))}
						</ProgressBar>
					</div>
				)//end progress js to return
			})}
			{
				(
					(
						dataToDisplay === 'all' ||
						dataToDisplay === 'simplified_nutrition'
					) &&
					compliance.simplified_nutrition.assigned
				) ?
					<div className={styles.EventData}>
						<Link
							to={`/eventsView?display=all&selector=all&filter=client&client=${clientId}&${trainerParam}`}
							className={styles.EventName}>
							<small>
								{isMAXUser ? `MAX Nutrition (${compliance.simplified_nutrition.days})` : "Simplified Nutrition"}
							</small>
						</Link>
						<ProgressBar
							onClick={() => {
								const complete = compliance.simplified_nutrition.completed
								const assigned = compliance.simplified_nutrition.assigned
								const notMet = assigned - complete
								const expandData = {
									clientName: user_name,
									title: isMAXUser ? `MAX Nutrition` : "Simplified Nutrition",
									linkText: "Nutrition",
									complete,
									notMet,
									open: 0,
									location: `/eventsView?display=all&selector=Nutrition&filter=client&client=${clientId}&${trainerParam}`
								}
								openExpandedDataHandler(expandData)
							}}
							className={styles.ProgressBar}>
							{[
								{
									percent: (
										compliance.simplified_nutrition.completed /
										compliance.simplified_nutrition.assigned
									) * 100,
									count: Math.round(compliance.simplified_nutrition.completed * 100) / 100,
									variant: 'success',
								}, {
									percent: (
										(
											compliance.simplified_nutrition.assigned -
											compliance.simplified_nutrition.completed
										) /
										compliance.simplified_nutrition.assigned
									) * 100,
									count: Math.round((
										compliance.simplified_nutrition.assigned -
										compliance.simplified_nutrition.completed
									) * 100) / 100,
									variant: 'danger',
								}
							].map((data, i) => (
								<ProgressBar
									variant={data.variant}
									now={data.percent}
									label={
										`${
										//only truncate to zero decimals if
										//the percentage is a non-int
										Math.round(data.percent) !== data.percent ?
											data.percent.toFixed(0) :
											data.percent
										}%`
									}
									key={i} />
							))}
						</ProgressBar>
					</div> :
					null
			}
		</div>
	)
}

const ClientRow = ({ clientId, dataToDisplay }) => {
	const client = useSelector(state => selectClientsById(state, clientId))
	//pull properties off client
	//console.log(client, "clients")
	const {
		user_id_number,
		profile_pic,
		user_name,
		compliance,
		user_trainer_id,
		gym_id,
		inactivate_account
	} = client
	//console.log(client, "totalClient")
	//console.log(compliance, "compliance")

	//pull tags from the accountTags slice
	const tags = useSelector(state => {
		if (!client) return []
		return client.tags.map(
			tag => state.accountTags.adapter.entities[tag.id]).filter(tag => Boolean(tag)
		)

	})
	const shared = user_trainer_id == gym_id
	
	return (
	 <>	{compliance ?
			<tr key={user_id_number} className={styles.ClientRow}>
				<td>
					<div className="d-flex align-items-center">
						<ProfileImage src={profile_pic} alt={user_name} />
						<ClientInfo
							inactivate_account={inactivate_account}
							tags={tags}
							user_id_number={user_id_number}
							user_name={user_name}
							shared={shared} />
					</div>
				</td>
				<td className="w-100">
					<Link 
						to={`/eventsView/?calendarEventType=all&view=calendar&selector=all&eventType=all&filter=client&client=${clientId}`}
						className="d-block text-center">
						<small>
							<i className="fa fa-calendar-check mr-2"/>
							Manage All Workouts/Tasks/Nutrition
						</small>
					</Link>
					<ComplianceInfo
						user_name={user_name}
						clientId={user_id_number}
						dataToDisplay={dataToDisplay}
						compliance={compliance}
					/>
				</td>
				<td>
					<div className="d-flex rowDiv" style={{justifyContent:"flex-end"}}>
						<RowOptions newMessageCount={client.trainerNewMessageFlag} clientId={user_id_number} />
					</div>
				</td>
			</tr>
		: null}
	
		</>
	)
}

export default ClientRow